import { useForm } from 'libs/form'
import { useTranslation } from 'libs/i18n'
import { Form } from 'shared/components'
import { InputGroup } from 'shared/molecules'
import { useFetchSaleQuery } from '../../queries/useFetchSaleQuery'
import { usePopulateSale } from './hooks/usePopulateSale'

interface SaleFormValues {
	created: string
	commission_percentage: string
	payout: string
	product_sku: string
	receipt_reference: string
	product_name: string
	unit_price: string
	quantity: string
	vat_percentage: string
	vat_amount: string
	subtotal: string
	discount: string
	total: string
	commission_amount: string
	user: string
}

export const FormSection = () => {
	const { t } = useTranslation()
	const { register, reset } = useForm<SaleFormValues>()
	const { saleData } = useFetchSaleQuery()

	usePopulateSale({
		data: saleData?.data,
		reset
	})

	return (
		<div className="px-4 lg:px-0">
			<Form>
				<InputGroup label={t('Account')} id="user" {...register('user')} disabled={true} />
				<InputGroup label={t('Created')} id="created" {...register('created')} disabled={true} />
				<InputGroup
					label={t('Reference')}
					id="ref"
					{...register('receipt_reference')}
					disabled={true}
				/>
				<InputGroup
					label={t('Product sku')}
					id="product_sku"
					{...register('product_sku')}
					disabled={true}
				/>
				<InputGroup
					label={t('Product name')}
					id="product_name"
					{...register('product_name')}
					disabled={true}
				/>
				<InputGroup
					label={t('Unit price')}
					id="unit_price"
					{...register('unit_price')}
					disabled={true}
				/>
				<InputGroup label={t('Quantity')} id="quantity" {...register('quantity')} disabled={true} />
				<InputGroup
					label={t('VAT percent')}
					id="vat_percent"
					{...register('vat_percentage')}
					disabled={true}
				/>
				<InputGroup
					label={t('VAT amount')}
					id="vat_amount"
					{...register('vat_amount')}
					disabled={true}
				/>
				<InputGroup label={t('Subtotal')} id="subtotal" {...register('subtotal')} disabled={true} />
				<InputGroup label={t('Discount')} id="discount" {...register('discount')} disabled={true} />
				<InputGroup label={t('Total')} id="total" {...register('total')} disabled={true} />
				<InputGroup
					label={t('Commission %')}
					id="commission_percent"
					{...register('commission_percentage')}
					disabled={true}
				/>
				<InputGroup
					label={t('Commission amount')}
					id="commission_amount"
					{...register('commission_amount')}
					disabled={true}
				/>
				<InputGroup label={t('Payout')} id="payout" {...register('payout')} disabled={true} />
			</Form>
		</div>
	)
}
